export default "__VITE_ASSET__BRHbRdbU__"